import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global voice recording cleanup hook
 * Automatically stops all voice recording when navigating between pages
 */
export const useVoiceRecordingCleanup = () => {
  const location = useLocation();
  const previousLocation = useRef<string>('');

  useEffect(() => {
    // Only cleanup if we've actually navigated to a different page
    if (previousLocation.current && previousLocation.current !== location.pathname) {
      console.log('Navigation detected, cleaning up voice recording...');

      // GlobalVoiceInputHandler (and any other capture component) listens for
      // this event and stops its own recognition/recorder and releases the
      // microphone stream. Never call getUserMedia here — requesting a new
      // stream just to stop it activates the mic on every navigation.
      const cleanupEvent = new CustomEvent('voice-recording-cleanup', {
        detail: { reason: 'navigation', from: previousLocation.current, to: location.pathname }
      });
      window.dispatchEvent(cleanupEvent);
    }

    // Update previous location
    previousLocation.current = location.pathname;
  }, [location.pathname]);
};

export default useVoiceRecordingCleanup;
